/* eslint-disable react/prop-types */
import { showNotification } from "@mantine/notifications";

const Toast = (title, message, color) => {
  showNotification({
    title: title,
    message: message,
    styles: (theme) => ({
      root: {
        backgroundColor:
          color != null ? theme.colors[color][6] : theme.colors.blue[6],
        borderColor:
          color != null ? theme.colors[color][6] : theme.colors.blue[6],

        "&::before": { backgroundColor: theme.white },
      },

      title: { color: theme.white },
      description: { color: theme.white },
      closeButton: {
        color: theme.white,
        "&:hover": {
          backgroundColor:
            color != null ? theme.colors[color][6] : theme.colors.blue[7],
        },
      },
    }),
  });
};

export default Toast;
